import { Component, OnDestroy, Input, ViewChild } from '@angular/core';
import { DxTreeViewComponent } from 'devextreme-angular';
import { FunctionDesc } from '../../models/configuration.model';
import { DataStoreService } from '../../core/services/data-store/data-store.service';
import { FunctionStoreService } from '../../services/function-store/function-store.service';
import { ConfigurationStoreService } from '../../services/configuration-store/configuration-store.service';
import { ViewSelectorService } from '../../services/view-selector/view-selector.service';
// TODO MK-REF
@Component({
  selector: 'baf-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css']
})
export class SideMenuComponent implements OnDestroy {
  private isAlive = true;
  noDataText = 'Tworzenie menu...';
  functions: FunctionDesc[];
  currentItem: FunctionDesc;

  @Input()
  height;

  @ViewChild(DxTreeViewComponent)
  private treeView: DxTreeViewComponent;

  constructor(
    configurationStore: ConfigurationStoreService,
    functionStore: FunctionStoreService,
    private viewSelector: ViewSelectorService,
    private storeService: DataStoreService
  ) {
    configurationStore.configurationStream.takeWhile(() => this.isAlive).subscribe(config => {
      this.functions = config.application.modules[0].functions;

      if (this.functions && this.functions.length > 0) {
        this.currentItem = this.getInnerNode(this.functions[0].functions)[0];
        if (this.currentItem) {
          this.viewSelector.setActiveView(this.currentItem);
          if (this.treeView) {
            this.treeView.instance.expandItem(this.currentItem);
          }
        }
      }
    });

    functionStore.allFunctionsStream.subscribe(functions => {
      this.functions = functions;
    });
  }

  getInnerNode(node: FunctionDesc[]): FunctionDesc[] {
    if (node && node.length > 0) {
      if (node[0].functions.length > 0) {
        return this.getInnerNode(node[0].functions);
      } else {
        return node;
      }
    } else {
      return node;
    }
  }

  onItemClick(event) {
    const item = <FunctionDesc>event.itemData;
    this.storeService.currentObjectId = item.id;
    if (item.functions && item.functions.length > 0) {
      return;
    }
    this.currentItem = event.itemData;
    this.viewSelector.setActiveView(this.currentItem);
  }
  onItemRendered(event) {
    const item = <FunctionDesc>event.itemData;
    this.storeService.currentObjectId = item.id;
  }

  ngOnDestroy() {
    this.isAlive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/side-menu/side-menu.component.ts